export const schedule_types_ids = {
  one_on_one_appointment: 0,
  one_on_one_class: 1,
  group_class: 2,
  workshop: 3,
  no_schedule: 4,
  content: 5,
  merchandise: 6,
  rolling_class: 7,
  telegram: 8,
  webinar: 9,
  whatsapp: 10,
  branded_community: 11,
};

export const address_type_enum = {
  meet: 0,
  joining_link: 1,
  personal_address: 2,
  customer_location: 3,
  zoom: 4,
  phone: 5,
  whatsapp: 6,
  exly_connect_by_zoom: 7,
  zoom_webinar: 8,
  none: 9,
  exly_zoom_webinar: 10,
};

export const address_type_data_map = {
  [address_type_enum.meet]: "Google meet",
  [address_type_enum.joining_link]: "Online Meeting Link",
  [address_type_enum.personal_address]: "At your personal address",
  [address_type_enum.customer_location]: "At customer's address",
  [address_type_enum.zoom]: "Zoom",
  [address_type_enum.phone]: "Phone",
  [address_type_enum.whatsapp]: "Whatsapp",
  [address_type_enum.exly_connect_by_zoom]: "Exly Zoom",
  [address_type_enum.none]: "None",
  [address_type_enum.exly_zoom_webinar]: "Exly Zoom Webinar",
};
